import { owaComputedFn } from 'owa-computed-fn';
import { defaultConfig } from 'owa-mail-ribbon-store-shared-types';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId, RibbonGroupId, RibbonTabId } from 'owa-ribbon-ids';
import type { TabScalingAndLayoutConfig } from 'owa-mail-ribbon-store-shared-types';
import type { RibbonControlDefinitionProps } from './RibbonControlDefinitionProps';
import { shouldShowRibbonControl } from './shouldShowRibbonControl';
import { shouldShowRibbonGroup } from './shouldShowRibbonGroup';

const getMLRDefaultTabConfig: (tabId: RibbonTabId) => TabScalingAndLayoutConfig | undefined =
    owaComputedFn(function getMLRDefaultTabConfig(
        tabId: RibbonTabId
    ): TabScalingAndLayoutConfig | undefined {
        switch (tabId) {
            case 1:
                return defaultConfig.multiline.homeTab;
            case 3:
                return defaultConfig.multiline.viewTab;
            default:
                return undefined;
        }
    });

/**
 * Returns the default visible control IDs for a given MLR group using the same
 * show/hide logic as the ribbon customizer's getControlsShouldShowMap.
 */
export const getDefaultMLRGroupControls: (
    groupId: RibbonGroupId,
    tabId: RibbonTabId,
    props: RibbonControlDefinitionProps
) => RibbonControlId[] = owaComputedFn(function getDefaultMLRGroupControls(
    groupId: RibbonGroupId,
    tabId: RibbonTabId,
    props: RibbonControlDefinitionProps
): RibbonControlId[] {
    if (!shouldShowRibbonGroup(tabId, groupId, undefined)) {
        return [];
    }

    const tabConfig = getMLRDefaultTabConfig(tabId);
    if (!tabConfig) {
        return [];
    }

    const group = tabConfig.layout.find(g => g.groupId === groupId);
    if (!group) {
        return [];
    }

    return group.controlIds.filter(controlId =>
        shouldShowRibbonControl(tabId, controlId, props, false /* isCustomizer */)
    );
});
